import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getFactoriesByGroupID,
    getAllRoutesByFactoryID,
    getAllCollectionTypesByoperationEntityID,
    getFalconReportData,
    getCustomersFromCollectionPoint,
    getTagWiseDetails,
    getDeductionTemplate,
    saveToTagChange,
    deleteTag,
    updateCustomer
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetFactoriesByGroupID','groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}


async function getAllRoutesByFactoryID(factoryID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + factoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;  
}

async function getAllCollectionTypesByoperationEntityID(operationEntityID) {
    var collectionTypeArray = [];
    const response = await CommonGet('/api/CollectionType/GetAllCollectionTypesByOperationEntityID', 'operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            collectionTypeArray[item[1]["collectionTypeMasterID"]] = item[1]["collectionTypeName"]
        }
    }
    return collectionTypeArray;  
}


async function getFalconReportData(data) {
    var model = {
        groupID : parseInt(data.groupID),
        factoryID: parseInt(data.factoryID),
        CollectionPointID: parseInt(data.routeID),
        date: data.date,
    };
    const response = await CommonPost('/api/ProductCollection/GetFalconProductCollectionDetails', null, model);
    return response.data;
}

async function getCustomersFromCollectionPoint(collectionPoint){
   
    const response = await CommonGet('/api/Customer/GetAllCustomerbyCollectionPointID', 'collectionPointID=' + collectionPoint);
    return response.data;
}

async function getTagWiseDetails(id){
   var obj={
    productCollectionID:id
   }
    const response = await CommonPost('/api/ProductCollection/GetCustomerTagDetails', null, obj);
  
    return response.data;
}

async function getDeductionTemplate(groupID,entityId,collectionPointID){
    const response = await CommonGet('/api/DeductionTemplate/GetAllDeductionTemplates', 'groupID=' + groupID + '&operationEntityId=' + entityId + '&collectionPointID=' + collectionPointID);
   
    return response.data;
}

async function saveToTagChange(data){
    const response = await CommonPost('/api/ProductCollection/UpdateTagwiseProductCollectionDetails', null, data);
   
    return response;
}

async function deleteTag(data){
    
    const response = await CommonPost('/api/ProductCollection/DeleteProductionDetails', null, data);
   
    return response;
}

async function updateCustomer(data){
    
    const response = await CommonPost('/api/ProductCollection/UpdateCustomerByProductCollectionID', null, data);
   
    return response;
}